<template>
  <div>
    <v-container grid-list-xl fluid>
      <table-app></table-app>
    </v-container>
  </div>
</template>

<script>
import TableApp from "@/components/table/TableApp";

export default {
  name: "AppsList",
  components: {
    TableApp
  }
};
</script>

<style scoped></style>
